import styled from "styled-components";

export const ListTitle = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
export const ListCategory = styled.div`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: var(--section-ebony-light-color, var(--ebony-light));
`;
export const ListQuantity = styled.span`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  color: var(--section-granite-color, var(--granite));
`;
